"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment_1 = __importDefault(require("moment"));

var lodash_1 = require("lodash");

var StringParserClass =
/** @class */
function () {
  function StringParserClass() {}

  return StringParserClass;
}();

exports.StringParserClass = StringParserClass;

var String =
/** @class */
function () {
  function String() {}

  String.parse = function (val, type) {
    if (type == "number") {
      return String.parseNumber(val);
    }

    if (type == "boolean") {
      return String.parseBoolean(val);
    }

    if (type == "date") {
      return String.parseDate(val);
    }

    return String.parseString(val);
  };

  String.parseString = function (val) {
    return val.trim();
  };

  String.parseNumber = function (val, def) {
    var arr = val.toString().replace(",", ".").replace(/[^\d.-]/gm, "").split(".");
    var s = arr.pop();

    if (arr.length > 0) {
      s = arr.join("") + "." + s;
    }

    var r = parseFloat(s);

    if (isNaN(r) && def !== undefined) {
      return def;
    }

    if (isNaN(r)) {
      return undefined;
    }

    return r;
  };

  String.parseBoolean = function (val) {
    var s = val.toString().trim();

    if (s === "0" || s === "false") {
      return false;
    } else {
      return Boolean(s);
    }
  };

  String.parseDate = function (val) {
    var s = val.toString().trim();
    var d = moment_1.default.utc(s, "DD/MM/YYYY HH:mm", true);

    if (!d.isValid()) {
      return new Date(0);
    }

    return d.toDate();
  };

  String.uniqKey = function (s, exists) {
    if (exists === void 0) {
      exists = [];
    }

    var key = lodash_1.deburr(s.toLowerCase()).replace(/[^\w ]/g, "").replace(" ", "-");

    if (exists.indexOf(key) > -1) {
      var i = 0;

      while (exists.indexOf(key + "-" + i.toString()) > -1) {
        i++;
      }

      key += "-" + i.toString();
    }

    return key;
  };

  String.parseArray = function (parser, separator) {
    return function (val) {
      separator = separator || ",";
      return val.split(separator).map(function (v) {
        return parser(v);
      });
    };
  };

  return String;
}();

exports.String = String;